// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-activity-events-container .text-right {
  text-align: right;
}
.user-activity-events-container .user-activity-event-item {
  width: 100%;
}
.user-activity-events-container .ant-list-header {
  padding-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/user-activity-events/styles.less"],"names":[],"mappings":"AAAA;EAEI,iBAAA;AAAJ;AAFA;EAMI,WAAA;AADJ;AALA;EAUI,4BAAA;AAFJ","sourcesContent":[".user-activity-events-container {\n  .text-right {\n    text-align: right;\n  }\n\n  .user-activity-event-item {\n    width: 100%;\n  }\n\n  .ant-list-header {\n    padding-bottom: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
